module.exports = __webpack_public_path__ + "static/media/icon-team-builder.8a1a6a17.svg";